import React, { useState, useContext, useEffect } from 'react';

import {
    Button,
    Box,
    Typography,
    Container,
    Select,
    MenuItem,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import Colors from '../../helpers/Colors';
import Assets from '../../helpers/assets';
import { AppContext } from '../../contexts/AppContext';
import { useHistory } from 'react-router';
import { fetchLocationTagMaps, fetchMetaDataList } from '../../services/OrderService';
import Modes from '../../contexts/Modes';
import { saveToStorage } from '../../services/LocalStorage';

export default function KitchenSelect() {
    const [error, setError] = useState(null);
    const [isRequestSent, setRequestSent] = useState(false);
    const [selections, setSelections] = useState([]);
    const [selected, setSelected] = useState();

    const { authData, setAuth, setLoggedIn, kitchen, setKitchen, setMode } = useContext(AppContext);
    const history = useHistory();

    const classes = useStyles();

    const onDashboardClick = () => {
        setLoggedIn(true);
        setMode(Modes.DRIVER_DASHBOARD);
        history.replace("/dashboard");
    }

    const onDispatcherClick = () => {
        setLoggedIn(true);
        setMode(Modes.DISPATCHER);
        history.replace("/dispatcher");
    }

    const onOrderReadyClick = () => {
        setLoggedIn(true);
        setMode(Modes.ORDER_READY);
        history.replace("/order-ready");
    }

    const onChangeLocation = (locationId) => {
        setSelected(locationId);

        const selectedLoc = selections.find((item) => item.id === locationId);

        const kitchen = {
            id: selectedLoc.multiTenant ? selectedLoc.multiTenantId : selectedLoc.id,
            name: selectedLoc.locationName,
            address: selectedLoc.address1,
            multiTenant: selectedLoc.multiTenant,
        };

        saveToStorage("kitchen", kitchen);
        setKitchen(kitchen);
    }

    useEffect(() => {
        if (!authData) {
            history.replace("/login");
        } else {
            fetchMetaDataList(
                authData.signInUserSession.idToken.payload.partner_id,
                authData.signInUserSession.idToken.payload.locationIds === 'ALL' ?
                    ['ALL'] :
                    JSON.parse(authData.signInUserSession.idToken.payload.locationIds))
                .then((response) => {
                    populateTagData(response);
                })
                .catch((error) => {
                    console.log("Token Expired", error);
                    setAuth(undefined);
                    history.replace("/login");
                });
        }

    }, []);

    const populateTagData = (locations) => {
        fetchLocationTagMaps(locations.map((loc) => loc.id))
        .then((response) => {
            console.log(response);

            const taggedOptions = locations.map((location) => {
                const taggedLoc = response[location.id];
                if (!taggedLoc) {
                    return null;
                }
                return {
                    ...location,
                    locationName: `${location.locationName} (${taggedLoc.id})`,
                    id: location.id + taggedLoc.id,
                    multiTenant: true,
                    multiTenantId: taggedLoc.id,
                }
            }).filter((loc) => loc !== null);

            setSelections([...locations, ...taggedOptions]);
        });
    }

    return (
        <Box className={classes.template}>
            <Container
                component="main"
                className={classes.container}
            >
                <img
                    src={Assets.logoWhite.default}
                    alt=""
                    className={classes.logo}
                />
                <Box className={classes.titleContainer}>
                    <Typography className={classes.title}>
                        Delivery Dashboard
          </Typography>
                </Box>

                <Box className={classes.paper}>
                    <Box className={classes.form} noValidate>
                        <Select
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            onChange={(event) => onChangeLocation(event.target.value)}
                            id="location"
                            name="location"
                            className={classes.usernameInput}
                            autoFocus
                            defaultValue={"select"}
                        >
                            <MenuItem value="select">Select Kitchen</MenuItem>
                            {
                                selections.map((item) => {
                                    return (<MenuItem value={item.id}>{item.locationName}</MenuItem>)
                                })
                            }
                        </Select>

                        <Box className={classes.buttonContainer}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={onDashboardClick}
                                disabled={!selected || selected === "select"}
                            >
                                {isRequestSent ? (
                                    <CircularProgress size={22} color="white" />
                                ) : (
                                        "DASHBOARD"
                                    )}
                            </Button>

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={onDispatcherClick}
                                disabled={!selected || selected === "select"}
                            >
                                {isRequestSent ? (
                                    <CircularProgress size={22} color="white" />
                                ) : (
                                        "DISPATCHER"
                                    )}
                            </Button>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={onOrderReadyClick}
                                disabled={!selected || selected === "select"}
                            >
                                {isRequestSent ? (
                                    <CircularProgress size={22} color="white" />
                                ) : (
                                    "ORDER READY"
                                )}
                            </Button>
                        </Box>
                    </Box>
                </Box>
                {error && (
                    <Box className={classes.errorContainer}>
                        <Typography className={classes.errorText}>
                            {error}
                        </Typography>
                        <img
                            src={Assets.error}
                            alt=""
                            className={classes.errorIcon}
                        />
                    </Box>
                )}
            </Container>
        </Box>
    );
}


const useStyles = makeStyles((theme) => ({
    template: {
        minHeight: 600,
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(34, 147, 249)',
        backgroundImage: `url(${Assets.loginBackground.default})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        margin: 0,
        padding: 0,
    },
    container: {
        marginTop: '8vh',
        height: '70vh',
        width: '40vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    paper: {
        width: '40vw',
        padding: 30,
        borderRadius: 8,
        maxWidth: 600,
        minWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        paddingBottom: 0,
        [theme.breakpoints.up('md')]: {
            width: 600,
        },

    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    usernameInput: {
        fontFamily: 'RobotoCondensed-Regular',
        fontWeight: 500,
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: Colors.blue,
        color: Colors.white,
        height: 45,
        fontSize: 18,
        boxShadow: 'none',
        fontFamily: 'SFProDisplay-Medium',
        '&:hover': {
            backgroundColor: Colors.blue,
            boxShadow: 'none',
        },
        marginLeft: '10px',
        marginRight: '10px',
        fontWeight: 500,
    },
    logo: {
        height: 50,
        width: '30vw',
        objectFit: 'contain',
        marginBottom: 10,
    },
    title: {
        fontSize: 22,
        color: Colors.white,
        fontFamily: 'SFProDisplay-Medium',
    },
    errorText: {
        color: Colors.white,
        fontSize: 17,
        fontFamily: 'SFProDisplay-Regular',
    },
    titleContainer: {
        padding: 5,
        paddingLeft: 40,
        paddingRight: 40,
        backgroundColor: Colors.blue,
        borderRadius: 22,
        marginTop: 5,
        marginBottom: 20,
    },
    alertBox: {
        marginTop: 50,
    },
    errorIcon: {
        height: 22,
        width: 22,
        objectFit: 'contain',
        marginLeft: 20,
    },
    errorContainer: {
        borderRadius: 13,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: '#DD2222',
        marginTop: 35,
        paddingLeft: 25,
        paddingRight: 25,
        paddingTop: 10,
        paddingBottom: 10,
    },
}));